import { API_V2 } from 'constant/apiUrl'
import { type Fetch } from 'lib/fetch/type'
import { type IAssetV2 } from 'type/asset'
import { type IRespV2 } from 'type/common'
import safeParseJson from 'util/safeParseJson'

const parseResponse = (text: string, ids: string) => {
  const idsArr = ids.split(',')

  // pre process text
  // replace "id":123 with "id":"123"
  for (const id of idsArr) {
    if (!id) {
      continue
    }
    text = text.replace(`"id":${id},`, `"id":"${id}",`)
  }

  return safeParseJson(text) || { code: 0, data: [] }
}

// V2
export const getAssetV2 = async (
  fetcher: Fetch,
  assetId: string
): Promise<IRespV2<IAssetV2>> => {
  const res = await fetcher(API_V2.ASSET + `/asset/${assetId}`, {
    method: 'GET',
    parseResponse: text => parseResponse(text, assetId)
  })

  return res
}

export const getAssetsV2 = async (
  fetcher: Fetch,
  ids: string
): Promise<IRespV2<IAssetV2[]>> => {
  const res = await fetcher(API_V2.ASSET + `/assets?ids=${ids}`, {
    method: 'GET',
    parseResponse: text => parseResponse(text, ids)
  })

  return res
}

export const createAssetV2 = async (
  fetcher: Fetch,
  id: string,
  image_metadata: {
    display_url: string
  }[]
): Promise<IRespV2> => {
  let body = JSON.stringify({
    id,
    image_metadata
  })

  // replace "id":"123" with "id":123
  body = body.replace(`"${id}"`, id)

  const res = await fetcher(API_V2.ASSET + `/asset`, {
    method: 'POST',
    body
  })

  return res
}
